import React, { useState } from 'react';
import { Box, Tabs, Tab } from '@mui/material';
import { DashboardLayout } from '@components/DashboardLayout.tsx';
import { PageHint } from '@components/common/PageHint.tsx';
import { PageIndices, TabIndices } from '../../common/i-doc/i-doc.registry.ts';
import { FeaturesTab } from './AdminEntitlementsPage/FeaturesTab';
import { PlanFeatureMatrixTab } from './AdminEntitlementsPage/PlanFeatureMatrixTab';
import { clientEntitlementsService } from '@services/client-entitlements.service.ts';

interface TabPanelProps {
  children?: React.ReactNode;
  index: number;
  value: number;
  tabId: string;
}

function TabPanel({ children, value, index, tabId }: TabPanelProps) {
  return (
    <div role="tabpanel" hidden={value !== index} data-i-doc={value === index ? tabId : undefined}>
      {value === index && <Box sx={{ pt: 2 }}>{children}</Box>}
    </div>
  );
}

const AdminClientEntitlementsPageContent: React.FC = () => {
  const [tab, setTab] = useState(0);

  return (
    <Box data-i-doc={PageIndices.ADMIN_CLIENT_ENTITLEMENTS}>
      <PageHint iDoc={PageIndices.ADMIN_CLIENT_ENTITLEMENTS} />

      <Box sx={{ borderBottom: 1, borderColor: 'divider' }}>
        <Tabs value={tab} onChange={(_e, v) => setTab(v)} aria-label="client entitlements tabs">
          <Tab label="Можливості" />
          <Tab label="Матриця планів" />
        </Tabs>
      </Box>

      <TabPanel value={tab} index={0} tabId={TabIndices.ADMIN_CLIENT_ENTITLEMENTS_FEATURES}>
        <FeaturesTab service={clientEntitlementsService} />
      </TabPanel>
      <TabPanel value={tab} index={1} tabId={TabIndices.ADMIN_CLIENT_ENTITLEMENTS_MATRIX}>
        <PlanFeatureMatrixTab />
      </TabPanel>
    </Box>
  );
};

export const AdminClientEntitlementsPage: React.FC = () => (
  <DashboardLayout>
    <AdminClientEntitlementsPageContent />
  </DashboardLayout>
);
